import React from 'react'
import { Link } from 'react-router-dom';

const Thumbnails = ({ id, src, title, publisher }) => {

    return (
         <Link to={`/video/${id}`} className="block">
            <div className='mt-6 mb-5 mx-4'>
                    <img 
                    src={src} 
                    alt ={title}
                    className="w-full w-[700px] md:w-[250px] lg:w-[300px] aspect-video overflow-hidden rounded-lg" 
                    />
                    <div className='mt-2'>
                        <p className="font-medium md:text-base text-sm">{title}</p>
                        <p className="text-gray-400 text-sm">{publisher}</p>
                    </div>
                </div>
        </Link>
    )
}

export default Thumbnails
